import { isDefined } from "@omni/utils/helper.utils";
import { RefObject, useEffect } from "react";

import { useWoosmapScript } from "@/services/woosmap/woosmap.initializer";
import { DamImage } from "@/utils/dam.utils";
import { ScriptLoadingStates } from "@/utils/hooks/useScript.hook";

import { ZOOM_INITIAL } from "../storeDirections.config";

let map: woosmap.map.Map | undefined;

export const useMap = (
    mapElementRef: RefObject<HTMLDivElement | null>,
    center: woosmap.map.LatLngLiteral
) => {
    const woosmapScriptLoadingState = useWoosmapScript();
    const ready = woosmapScriptLoadingState === ScriptLoadingStates.Ready;

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!ready) return;
        if (!isDefined(mapElementRef.current)) return;

        map ||= new woosmap.map.Map(mapElementRef.current, {
            center: center,
            zoom: ZOOM_INITIAL
        });

        const marker = new woosmap.map.Marker({
            position: center,
            icon: DamImage.icon.maps.marker,
            map: map
        });

        marker.setMap(map);
    }, [ready]);

    return map;
};
